import React, { Component } from 'react';
import BackgroundSection from './BackgroundSection';
import Footer2 from './Footer2';
import One from './8900_LivingRoom.jpg';
import Two from './GalleryPhotos/8900_Front2.jpg';
import Three from './435_Front.jpg';
import Four from './435_DiningRoom.jpg';
import Fade from 'react-reveal/Fade';
import FurnishedLiving from './FurnishedLiving';
import GoToGallery from './GoToGallery';
import { Link } from 'react-router-dom';
import Amenities from './Amenities';
import { ParallaxProvider } from 'react-scroll-parallax';
import HalfBackgroundParallax from './HalfBackgroundParallax';
import SEOHiddenText from './SEOHiddenText';

class Home extends Component {
  constructor(){
    super()
    this.state = {
      scrollHeight: document.documentElement.scrollTop
    }
  }
  componentWillMount(){
    // window.addEventListener('scroll', () => this.setState({scrollHeight: document.documentElement.scrollTop}))
    this.props.changeClass();
  }
  componentWillUnmount(){
    // window.removeEventListener('scroll', () => this.setState({scrollHeight: document.documentElement.scrollTop}))
  }
  render(){
    return (
      <div>
        <ParallaxProvider>
          <div>
            <SEOHiddenText />
            <BackgroundSection reactKey={0} name={"jumbotron"} scrollHeight={this.state.scrollHeight} imageUrl={imgUrlArray} start={100} noFilter={false} />
            <div style={{background: 'linear-gradient(to bottom right, #fdfdfd, #f5f4e9'}}>
              <FurnishedLiving title={furnishedLivingObj.title} text1={furnishedLivingObj.text1} text2={furnishedLivingObj.text2} />
              <Amenities reactKey={1.6} scrollHeight={this.state.scrollHeight}/>
              <div style={{clear: 'both'}}></div>
              <GoToGallery content='gallery' />
            </div>
            <HalfBackgroundParallax />
            </div>
        </ParallaxProvider>
      </div>
    )
  }
}

var imgUrlArray = [
  'url(' + One + ')',
  'url(' + Two + ')',
  'url(' + Three +')',
  'url(' + Four +')'
]

var imgUrlArray2 = [
  'url(' + Two + ')'
]

export default Home;

// CONTENT
const CTObjMaker = (x, y, z) => {
  return {title: x, text: y, width: z}
}
var furnishedLivingObj = {
  title: 'Furnished Living',
  text1: 'Our luxury furnished apartments are situated in the finest areas of West Hollywood and Santa Monica. We offer long-term rentals (31 days minimum) in our studio, one-bedroom, and two-bedroom apartments. Each unit is finished with fine appliances and detailed decorations. We balance style and comfort to provide a home away from home.' ,
  text2: 'Our properties are situated in the best parts of West Hollywood and Santa Monica. In West Hollywood we are short walk to Robertson and 3rd. In Santa Monica, you can find us on Montana Ave, just steps to the beach. We provide everything you need on your long-term stay in Los Angeles to make sure you will enjoy your stay.',
  buttonText: 'Explore Floor Plans'
}
const str1 = 'Our luxury furnished apartments are situated in the finest areas of West Hollywood and Santa Monica. We offer long-term rentals in our studio, one-bedroom, and two-bedroom apartments finished with state-of-the-art appliances and detailed decorations. We balance style and comfort to provide a home away from home.'
const str2 = 'Take a glimpse into our property and get lost in the sophisticated comfort lifestyle. Rent apartments with the luxury amenities you need, such as high-speed internet, and in-apartment hi-tech washers and dryers.'
const CTObj1 = CTObjMaker('Our Standard', str1, '50%')
const CTObj2 = CTObjMaker('Design, Luxury and Comfort', str2, '71%')
const columnClasses = {col1: 'col-lg-6 col-md-6 col-sm-6', col2: 'col-lg-6 col-md-6 col-sm-6'}



// WEBPACK FOOTER //
// ./src/Home.js